import React from "react";
import { CtaButton } from "./CtaButton";
import { images } from "../data/offer";
export function AuthorSection() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-24" data-id="element-20" data-mp="saee1xygfv3l">
      <div className="mx-auto grid max-w-6xl items-start gap-10 lg:grid-cols-[2fr_3fr] lg:gap-16" data-id="element-21" data-mp="178zzxpz1t6ze">
        <div className="-mx-4 sm:mx-0 lg:sticky lg:top-8" data-id="element-22" data-mp="128u4rztkl2ck">
          <img src={images.author} alt="Dr. Ryan Carter" className="aspect-[4/5] w-full object-cover sm:rounded-3xl" loading="lazy" data-id="element-23" data-mp="127akzz8pg961" />
        </div>

        <div data-id="element-24" data-mp="9iv8bjd1q2xv">
          <p className="font-display text-xl font-semibold uppercase tracking-wide text-navy-700" data-id="element-25" data-mp="o9m412hrdm69">
            A note from Dr. Ryan Carter
          </p>
          <h2 className="mt-2 font-display text-[2rem] font-bold uppercase leading-[1.08] text-ink sm:text-5xl" data-id="element-26" data-mp="jhb25u3gjqb2">
            Why I organized Diabetic Foot Assessment Blueprint™
          </h2>
          <div className="mt-6 space-y-4 text-lg leading-relaxed text-ink-soft" data-id="element-27" data-mp="3myt9m0fbivay">
            <p data-id="element-28" data-mp="2von4jp0uvoi7">
              When you're reviewing diabetic foot assessment, it's easy to focus on one area at a time: skin changes,
              protective sensation, circulation, wounds, or risk factors.
            </p>
            <p className="font-semibold text-ink" data-id="element-29" data-mp="34gp6jrqkpcul">
              But a comprehensive assessment involves considering how different pieces of information fit together.
            </p>
            <p data-id="element-30" data-mp="2cq15efowg7gx">
              I organized this blueprint around that principle — with dedicated volumes for assessment concepts,
              finding descriptions, risk factors, warning signs, and clinical reasoning, plus practical checklists,
              reference cards, documentation templates, and educational case exercises.
            </p>
            <p data-id="element-31" data-mp="2qmedwzbggyj9">
              My intention is to give you an organized supplementary resource that you can use to review concepts,
              structure your learning, and prepare your documentation approach within your professional scope.
            </p>
            <p data-id="element-32" data-mp="3cegzrzx0infk">
              I don't want you to see this as a replacement for clinical training, current guidelines, or professional
              judgment. Instead, I want it to serve as a reference you can revisit when you need to review an assessment
              topic or organize the information relevant to a case.
            </p>
            <p data-id="element-33" data-mp="3hd0rkgyaetfu">
              If you're looking for a single educational collection covering these important areas of diabetic foot
              assessment, I created this blueprint with you in mind.
            </p>
          </div>
          <p className="mt-6 font-display text-3xl font-semibold italic text-ink" data-id="element-34" data-mp="33fc4d2gqza7m">Dr. Ryan Carter</p>

          <div className="mt-10" data-id="element-35" data-mp="2yo3te1zrrgsc">
            <CtaButton label="Start organizing today" data-id="element-36" data-mp="2ymsofyul82zn" />
          </div>
        </div>
      </div>
    </section>;
}